// src/components/BalancesCard.jsx
import { useEffect, useState } from "react";
import api from "../utils/api";

export default function BalancesCard({ userId }) {
    const [data, setData] = useState({ alpaca: {}, tradier: {} });

    useEffect(() => {
        if (!userId) return;
        const mode = (localStorage.getItem("trade_mode") || "paper").toLowerCase();

        api.get("/api/brokers/balances", {
            params: { user_id: userId, mode },
        })
            .then((res) => setData(res.data || {}))
            .catch((err) => console.error("balances error", err));
    }, [userId]);

    const Row = ({ label, v }) => (
        <div className="flex justify-between text-sm">
            <span className="text-zinc-400">{label}</span>
            <span>{v ?? "�"}</span>
        </div>
    );

    const Section = ({ title, broker }) => {
        const b = data[broker] || {};
        return (
            <div>
                <div className="flex items-center justify-between mb-1">
                    <div className="font-semibold">{title}</div>
                    <span className="text-xs text-zinc-400">
                        {b.env ? b.env.toUpperCase() : ""}
                    </span>
                </div>
                <Row label="Account" v={b.account_id} />
                <Row label="Cash" v={b.cash} />
                <Row label="Buying Power" v={b.buying_power} />
                {broker === "tradier" && (
                    <>
                        <Row label="Options BP" v={b.option_buying_power} />
                        <Row label="Acct Value" v={b.account_value} />
                    </>
                )}
                {broker === "alpaca" && (
                    <Row label="Portfolio" v={b.portfolio_value} />
                )}
            </div>
        );
    };

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Balances</h3>
            <div className="grid grid-cols-2 gap-4">
                <Section title="Alpaca" broker="alpaca" />
                <Section title="Tradier" broker="tradier" />
            </div>
        </div>
    );
}
